// Client mirror of functions-common/src/charts/engine/cap.ts. Keep in sync.

import type { ChartSeries } from '../types.js'

export function capSeriesPoints(
  seriesList: ChartSeries[],
  maxPoints: number = 500
): { series: ChartSeries[]; truncated: boolean } {
  let truncated = false

  const capped = seriesList.map((series) => {
    if (series.points.length > maxPoints) {
      truncated = true
      return {
        ...series,
        points: series.points.slice(0, maxPoints),
      }
    }
    return series
  })

  return { series: capped, truncated }
}
